/* eslint-disable @typescript-eslint/restrict-plus-operands */
export const Pad = (val: string | number, n: number) => ('000000000' + val).substr(-n);
